import RoutesConfig from "./routes";

import "./App.css";
import "./comm/util/string-extension"
import {setCommonParameters} from "./comm/util/MyLocalStorage";
function App() {
    setCommonParameters(window.location.href
        .replaceAll("??", "?")
        .replaceAll("&?", "&").split('?')[1])
    return (
        <div>
            <div className="App">
                <RoutesConfig/>
            </div>
        </div>
    );
}


export default App;
